export class PartnerTitle {
  code: number;
  name: string;

  constructor(
    code: number,
    name: string,
  ) {
    this.code = code;
    this.name = name;
  }

  static createFromAny(object: any): PartnerTitle {
    if (object === null || object === undefined) {
      return null;
    }

    return new PartnerTitle(
      +object.code,
      object.name,
    );
  }

}
